import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// report-common
import { getReportSelectors } from '../../../report-common/selectors';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('ratingGeoFencingZone');

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => R.compose(
    R.map((item) => R.assoc(
      'disabled',
      G.notPropEq(G.getAmousCurrentBranchGuidFromWindow(), GC.BRANCH_GUID, item),
      item,
    )),
    R.sortBy(R.prop('index')),
    R.values,
  )(R.or(itemList, {})),
);

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectPageVisited,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
};
